
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import AuthReducer from "./Reducer/AuthReducer";
import WithdrawalReducer from "./Reducer/WithdrawalReducer";
import ReportsReducer from "./Reducer/ReportsReducer";
import CallReducer from "./Reducer/CallReducer";

const rootReducer = combineReducers({
    Auth:AuthReducer,
    Withdraw: WithdrawalReducer,
    Reports: ReportsReducer,
    Call: CallReducer,
});

const initialState = {};

const middlewares = [thunk];
const middlewareEnhancer = applyMiddleware(...middlewares);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancers = [middlewareEnhancer];
const composedEnhancers = composeEnhancers(...enhancers);

const store = createStore(rootReducer, initialState, composedEnhancers);

store.dispatch({ type: "INIT" });

export default store;
